// GENERATED from ssi-dashboard-v7-clean ops/talk-bollocks-ita-1/manifest-checked.json (job #323,
// the CHECKED Part 1: 213 clips, 32 corrected) by job #360. Do not hand-edit; regenerate from that file.
export const TALK_BOLLOCKS_ITA_1_SCENE_NAMES: Record<string, string> = {
  "2": "I metodi tradizionali e l'IA",
  "3": "Le parole non esistono",
  "4": "Holy Dickhead Batman",
  "5": "La ripetizione dilazionata",
  "6": "Tempo contro efficienza"
}

export const TALK_BOLLOCKS_ITA_1_ROWS = [
 {
  "id": "talk-bollocks-1:1",
  "scene_number": 1,
  "sentence_number": 1,
  "global_order": 1,
  "speaker": "Tom",
  "target_text": "Qui Tom e Aran che dicono cazzate, Parte 1.",
  "known_text": "",
  "target_audio_id": "trial_2F9D5A6A-E05D-4AE1-97BE-1BEF7AF02D2E",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:2",
  "scene_number": 1,
  "sentence_number": 2,
  "global_order": 2,
  "speaker": "Aran",
  "target_text": "Ma scrivi \"Parte 1 di 18 milioni\"?",
  "known_text": "",
  "target_audio_id": "trial_F3926244-F4FE-4B4A-885A-80EFCED97A0F",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:3",
  "scene_number": 1,
  "sentence_number": 3,
  "global_order": 3,
  "speaker": "Tom",
  "target_text": "Sì, esatto. Chi lo sa? Okay. Dai, partiamo da dove capita.",
  "known_text": "",
  "target_audio_id": "trial_1DB27E5D-CA5C-40D0-8DDD-CFA8F09F387A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:4",
  "scene_number": 1,
  "sentence_number": 4,
  "global_order": 4,
  "speaker": "Aran",
  "target_text": "Allora, alla fine è tutta una questione di IA – non è una cosa dietro l'angolo – ci sono un sacco di cose di valore che si possono fare prima di arrivarci, ma il punto è prepararsi all'IA.",
  "known_text": "",
  "target_audio_id": "trial_AF00C385-7256-4F2F-8E74-8D6B6FB15D31",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:5",
  "scene_number": 1,
  "sentence_number": 5,
  "global_order": 5,
  "speaker": "Aran",
  "target_text": "Quindi se prendi un qualsiasi approccio esistente all'apprendimento delle lingue e provi a costruirci sopra un modo per inserire l'IA, avrà un valore molto limitato.",
  "known_text": "",
  "target_audio_id": "trial_5B5F8DEC-65A5-419A-80AB-D0D2DB03F003",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:6",
  "scene_number": 1,
  "sentence_number": 6,
  "global_order": 6,
  "speaker": "Aran",
  "target_text": "Sono sicuro che qualcosa si potrà fare – IA diverse per attività o conoscenze diverse – quindi non è che sia impossibile, che non si possa aggiungere...",
  "known_text": "",
  "target_audio_id": "trial_7B18297E-3F05-47A7-975D-7E7A1C060A2A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:7",
  "scene_number": 1,
  "sentence_number": 7,
  "global_order": 7,
  "speaker": "Tom",
  "target_text": "Allora, per aiutarci a capire un po' meglio, ragioniamo per esempi. Il modello tradizionale sarebbe tipo... cosa? Dammi qualche esempio...",
  "known_text": "",
  "target_audio_id": "trial_A2274C21-5E14-4224-A5DB-80D8F6EFE84E",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:8",
  "scene_number": 1,
  "sentence_number": 8,
  "global_order": 8,
  "speaker": "Aran",
  "target_text": "Ce ne sono tantissimi! Il grande problema oggi, nell'acquisizione delle lingue seconde come campo accademico, è che c'è un consenso: ci sono forse sei o sette teorie principali. Nessuna è del tutto sbagliata e nessuna è del tutto giusta.",
  "known_text": "",
  "target_audio_id": "trial_1BCE8447-497F-419E-8D74-A735421907C3",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:9",
  "scene_number": 1,
  "sentence_number": 9,
  "global_order": 9,
  "speaker": "Aran",
  "target_text": "Quindi hai questo consenso accademico per cui ognuna ha il suo valore e non esiste un modo giusto di farlo. Ed è affascinante, perché è proprio il tipo di consenso accademico che mette radici profondissime in un campo di ricerca. E secondo me è fondamentalmente sbagliato.",
  "known_text": "",
  "target_audio_id": "trial_36BEFCE8-2E54-477F-8535-B3B0D888B7BA",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:10",
  "scene_number": 1,
  "sentence_number": 10,
  "global_order": 10,
  "speaker": "Aran",
  "target_text": "Secondo me l'idea è: abbiamo provato a capire 'sta cosa, non ci siamo riusciti, e abbiamo concluso che ci sono tanti elementi.",
  "known_text": "",
  "target_audio_id": "trial_11767F81-A19B-416D-8B39-20DAE97702F1",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:11",
  "scene_number": 1,
  "sentence_number": 11,
  "global_order": 11,
  "speaker": "Aran",
  "target_text": "E per me è delicato, perché ho degli amici davvero in gamba che sono ricercatori fantastici di acquisizione delle lingue seconde, figure importantissime del settore, e danno contributi brillanti e fanno un lavoro bellissimo.",
  "known_text": "",
  "target_audio_id": "trial_BDB2FB55-9AA6-46E7-9553-BB1D06539661",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:12",
  "scene_number": 1,
  "sentence_number": 12,
  "global_order": 12,
  "speaker": "Aran",
  "target_text": "Non è colpa di nessuno in particolare, ma c'è questo consenso accademico globale per cui funzionano tutte un po'.",
  "known_text": "",
  "target_audio_id": "trial_D0F0089F-BC93-4915-86E3-186CAACA2120",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:13",
  "scene_number": 1,
  "sentence_number": 13,
  "global_order": 13,
  "speaker": "Aran",
  "target_text": "E poi la ricerca che ne segue consiste nello scendere in dettagli minuscoli e vedere se quella certa cosa si può dimostrare utile o no, invece di dire: aspetta, facciamo un passo indietro.",
  "known_text": "",
  "target_audio_id": "trial_279EA31A-433B-4D70-8E83-4C0C144DC7A3",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:14",
  "scene_number": 1,
  "sentence_number": 14,
  "global_order": 14,
  "speaker": "Aran",
  "target_text": "E poi c'è un altro problema, secondo me, nella ricerca accademica su questo tema: finora c'è poca sovrapposizione col lavoro fatto sulla neuroplasticità. Non è ancora normale che un ricercatore di acquisizione delle lingue seconde sia ferrato su quello che succede con la neuroplasticità.",
  "known_text": "",
  "target_audio_id": "trial_2B012BCC-6DDA-4E3E-8130-B9F7116AAEE3",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:15",
  "scene_number": 1,
  "sentence_number": 15,
  "global_order": 15,
  "speaker": "Aran",
  "target_text": "E secondo me è un problema, perché questi ricercatori guardano una scatola nera. E cercano di capire come si arriva a certi risultati cambiando gli input. E lo fanno con un sacco di test. È una cosa complicatissima.",
  "known_text": "",
  "target_audio_id": "trial_2E580A0D-BDA2-4CD7-A932-D634DDE6D290",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:16",
  "scene_number": 1,
  "sentence_number": 16,
  "global_order": 16,
  "speaker": "Aran",
  "target_text": "In pratica sono bendati e devono trovare le risposte, quindi certi passaggi del ragionamento nella ricerca sono di una creatività e di un'intelligenza pazzesche. Ma nella neuroplasticità, invece, tolgono di continuo il coperchio alla scatola e guardano cosa succede dentro.",
  "known_text": "",
  "target_audio_id": "trial_A8BF33F4-0719-4C62-AE0E-A9287BD6DF9A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:17",
  "scene_number": 1,
  "sentence_number": 17,
  "global_order": 17,
  "speaker": "Aran",
  "target_text": "Per esempio, ho avuto una conversazione con un ricercatore molto rispettato, e parlavamo di questo: se rafforziamo la capacità di produrre, di parlare, nello stesso momento in cui rafforziamo l'ascolto, la comprensione. Cioè, otteniamo un doppio vantaggio in un unico circuito neurale?",
  "known_text": "",
  "target_audio_id": "trial_8C32D5E3-7D36-479F-9DA7-F7EAC48457F0",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:18",
  "scene_number": 1,
  "sentence_number": 18,
  "global_order": 18,
  "speaker": "Aran",
  "target_text": "E io devo dire di no, non è così, perché un principio fondamentale di come capiamo il cervello è che in un circuito neurale l'informazione scorre in una direzione sola. È così che funziona. Non esistono circuiti inversi.",
  "known_text": "",
  "target_audio_id": "trial_53D2355E-978D-4913-810A-07B06F70D57C",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:19",
  "scene_number": 1,
  "sentence_number": 19,
  "global_order": 19,
  "speaker": "Aran",
  "target_text": "Quindi quando produciamo il parlato abbiamo un circuito neurale, e quando decodifichiamo quello che ci dice un altro è un circuito diverso – non possono essere lo stesso circuito. Poi ci sono cose interessanti lì dentro, ovviamente: è tutto ancora da scoprire.",
  "known_text": "",
  "target_audio_id": "trial_FEDE14D5-FEBB-4E2C-A54E-FEAB9838A09A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:20",
  "scene_number": 1,
  "sentence_number": 20,
  "global_order": 20,
  "speaker": "Aran",
  "target_text": "Quando sappiamo che la parola per \"pesce\" in gallese è pysgod, abbiamo un unico circuito neurologico centrale, molto denso, che collega quelle due parole?",
  "known_text": "",
  "target_audio_id": "trial_D94D4D24-8D8A-4ABD-A2D3-6F51B8073372",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:21",
  "scene_number": 1,
  "sentence_number": 21,
  "global_order": 21,
  "speaker": "Aran",
  "target_text": "Oppure abbiamo un circuito separato dove si stabilisce che pysgod è questo tipo di animale, e poi c'è solo un collegamento, un piccolo flusso di informazione che va in entrambe le direzioni?",
  "known_text": "",
  "target_audio_id": "trial_FD34346A-DAE3-4D17-B501-7F5506FE264A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:22",
  "scene_number": 1,
  "sentence_number": 22,
  "global_order": 22,
  "speaker": "Aran",
  "target_text": "O abbiamo quel tipo di struttura per il parlare, e poi un'altra struttura separata che fa lo stesso lavoro per il capire? Non lo sappiamo – non ci sono risposte.",
  "known_text": "",
  "target_audio_id": "trial_90F12312-E6CF-4E54-9303-A9229CD89532",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:23",
  "scene_number": 1,
  "sentence_number": 23,
  "global_order": 23,
  "speaker": "Aran",
  "target_text": "E io credo davvero che questi ricercatori debbano fare più attenzione a quello che stanno scoprendo i neuroscienziati della plasticità, e uno dei motivi, secondo me,",
  "known_text": "",
  "target_audio_id": "trial_05DBE470-E56A-4890-8924-AF8A062A9558",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:24",
  "scene_number": 1,
  "sentence_number": 24,
  "global_order": 24,
  "speaker": "Aran",
  "target_text": "è che una delle cose geniali della neuroplasticità è il lavoro che si sta facendo per capire come la si innesca e in che ambienti la si innesca.",
  "known_text": "",
  "target_audio_id": "trial_E10FEDC6-64A1-47DC-824E-28907CD29EA2",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:25",
  "scene_number": 1,
  "sentence_number": 25,
  "global_order": 25,
  "speaker": "Aran",
  "target_text": "Per esempio, se una persona ha perso la sensibilità in una gamba, e le metti uno specchio tra le gambe e poi accarezzi la gamba che sente, ma visivamente a lei sembra di vedere accarezzare la gamba che non sente, questo può far tornare un po' di sensazione nella gamba.",
  "known_text": "",
  "target_audio_id": "trial_35A14BE5-7DEA-47BC-906F-D487B6EBB6F7",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:26",
  "scene_number": 1,
  "sentence_number": 26,
  "global_order": 26,
  "speaker": "Aran",
  "target_text": "C'è gente che lavora sulla decodifica di informazioni digitali per dare a qualcuno la capacità di sentire quando l'udito non funziona, o di vedere quando gli occhi non funzionano. Quindi è questa ricerca gigantesca dello stimolo minimo efficace per innescare il cambiamento.",
  "known_text": "",
  "target_audio_id": "trial_7E91FE79-E282-45FE-B8F6-8B59F7DED88C",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:27",
  "scene_number": 1,
  "sentence_number": 27,
  "global_order": 27,
  "speaker": "Aran",
  "target_text": "Ed è proprio questa l'educazione, no? Cerchiamo le cose che possiamo dire per innescare apprendimento e crescita. Non ho idea di quale fosse la domanda iniziale – qualcosa sulla metodologia?",
  "known_text": "",
  "target_audio_id": "trial_379C7122-FEBC-47E6-A23A-FF5BB8B16AB2",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:28",
  "scene_number": 2,
  "sentence_number": 28,
  "global_order": 28,
  "speaker": "Tom",
  "target_text": "È interessante.",
  "known_text": "",
  "target_audio_id": "trial_9C3C1CF7-845C-49DB-8A40-DD7F0753B0EE",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:29",
  "scene_number": 2,
  "sentence_number": 29,
  "global_order": 29,
  "speaker": "Tom",
  "target_text": "Prima di tornare alla domanda iniziale, vorrei approfondire, dal tuo punto di vista, questi sei o sette approcci all'apprendimento che, come dicevi, secondo i ricercatori sono più o meno ugualmente validi – lasciando stare il fatto che le cose non possono essere esattamente ugualmente valide,",
  "known_text": "",
  "target_audio_id": "trial_483ED5B9-9EA6-4977-B8FD-08477D3AE0DF",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:30",
  "scene_number": 2,
  "sentence_number": 30,
  "global_order": 30,
  "speaker": "Tom",
  "target_text": "a meno che tu non le misuri male – e non sanno fino a che punto uno sia più importante e più apprendibile di un altro. E se hai risorse limitate, dove ti conviene spendere il tuo tempo, come singola persona, tra queste 17 caratteristiche?",
  "known_text": "",
  "target_audio_id": "trial_1CCAC7C2-F8B6-4112-8D5D-31B7833F17D1",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:31",
  "scene_number": 2,
  "sentence_number": 31,
  "global_order": 31,
  "speaker": "Tom",
  "target_text": "È praticamente certo che non siano tutte uguali... Anche se fossi lo studente medio, non lo sarebbero quasi sicuramente. Quindi fino a che punto queste cose fanno davvero la differenza, e quanto valgono questi approcci diversi, anche se hanno pro e contro, non possiamo misurarlo.",
  "known_text": "",
  "target_audio_id": "trial_89C1DE34-8475-4C7C-B6C5-E3BECEC75916",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:32",
  "scene_number": 2,
  "sentence_number": 32,
  "global_order": 32,
  "speaker": "Tom",
  "target_text": "Ma lasciando perdere tutto questo, dammi uno o due esempi di un modo tipico di imparare una lingua, e di perché non si presta all'IA, mentre invece la nostra metodologia magari sì?",
  "known_text": "",
  "target_audio_id": "trial_47E5CA79-1C74-48E0-94F9-C4E9CF3D2CC3",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:33",
  "scene_number": 2,
  "sentence_number": 33,
  "global_order": 33,
  "speaker": "Aran",
  "target_text": "Allora, il problema di fondo di questo consenso, o almeno per me, è che tutti pensano che per acquisire una lingua si debbano fare due cose: devi acquisire il vocabolario,",
  "known_text": "",
  "target_audio_id": "trial_C56A46A5-6E02-48DC-B167-632B07A17261",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:34",
  "scene_number": 2,
  "sentence_number": 34,
  "global_order": 34,
  "speaker": "Aran",
  "target_text": "e poi devi sviluppare una specie di schema grammaticale che ti permetta di mettere il vocabolario nell'ordine giusto per comunicare.",
  "known_text": "",
  "target_audio_id": "trial_4810FB4B-3217-4C53-A433-E1C52C7E74E2",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:35",
  "scene_number": 2,
  "sentence_number": 35,
  "global_order": 35,
  "speaker": "Aran",
  "target_text": "E questo è più o meno uguale per tutti – anche se magari hanno modi diversi di fare queste due cose – in fondo si tratta di unità di conoscenza vera e propria, il vocabolario, e poi di modi per mettere insieme le parole in modo che abbiano senso grammaticale.",
  "known_text": "",
  "target_audio_id": "trial_81AE97AD-02A0-4BBB-B676-8536DEA6F8D9",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:36",
  "scene_number": 2,
  "sentence_number": 36,
  "global_order": 36,
  "speaker": "Aran",
  "target_text": "Il problema – e in neuroplasticità c'è un principio standard che ti serve davvero: se vedi succedere qualcosa di complicato, e pensi di avere una soluzione,",
  "known_text": "",
  "target_audio_id": "trial_B84E860C-BAC4-4D4D-AFFC-963F75F57E56",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:37",
  "scene_number": 2,
  "sentence_number": 37,
  "global_order": 37,
  "speaker": "Aran",
  "target_text": "devi proprio chiederti come funzionerebbe a livello dei neuroni – ovviamente qui stiamo solo sfiorando la superficie – ma ci sono cose che sappiamo abbastanza bene.",
  "known_text": "",
  "target_audio_id": "trial_3C5B26F9-AFC6-4CE4-9FB5-88D17FBB823A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:38",
  "scene_number": 2,
  "sentence_number": 38,
  "global_order": 38,
  "speaker": "Aran",
  "target_text": "Quindi la domanda per me – e puoi farla in un sacco di campi diversi, in tutto quello che riguarda le persone e quello che fanno e come lo fanno – è quasi sempre interessante chiedersi: ok, cosa succede a livello neurologico, come gira la cosa?",
  "known_text": "",
  "target_audio_id": "trial_53459F32-1875-4E0B-B893-470B446CCD80",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:39",
  "scene_number": 2,
  "sentence_number": 39,
  "global_order": 39,
  "speaker": "Aran",
  "target_text": "Abbiamo questo motore centrale, questo dispositivo, che guida una percentuale enorme di chi siamo e di quello che facciamo. E stiamo cominciando a capirne dei pezzi. Quindi quando dici, come acquisiamo il vocabolario – dal punto di vista neurologico non è particolarmente complicato.",
  "known_text": "",
  "target_audio_id": "trial_3317EF72-BA9C-4879-A7ED-461C3C483BCF",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:40",
  "scene_number": 2,
  "sentence_number": 40,
  "global_order": 40,
  "speaker": "Aran",
  "target_text": "Non è proprio semplice, ma abbiamo un'idea generale: i neuroni e le sinapsi codificano le informazioni. Stiamo scoprendo cose interessanti su quanto durano i diversi tipi di informazione. Cos'è in pratica la memoria a breve termine? Cos'è la memoria a lungo termine?",
  "known_text": "",
  "target_audio_id": "trial_90B33543-A435-4AFE-98EA-9AD5CCED9DA5",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:41",
  "scene_number": 2,
  "sentence_number": 41,
  "global_order": 41,
  "speaker": "Aran",
  "target_text": "Sono in posti diversi? Sappiamo che c'entra l'ippocampo – il passaggio dall'una all'altra. Non abbiamo ancora un modello del tipo \"ecco come funziona\".",
  "known_text": "",
  "target_audio_id": "trial_AA9AB4EC-7AFD-4BFD-81DC-27A1B0FD93FA",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:42",
  "scene_number": 2,
  "sentence_number": 42,
  "global_order": 42,
  "speaker": "Aran",
  "target_text": "Ma facciamo conto che in media il collegamento tra una parola e un'immagine o un concetto coinvolga qualche migliaio di neuroni, collegati in un gruppo che si occupa di cose come sillabe e forme dei suoni e tutta quella roba.",
  "known_text": "",
  "target_audio_id": "trial_06F8412C-9D3E-4F1D-A97E-624680EA2424",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:43",
  "scene_number": 2,
  "sentence_number": 43,
  "global_order": 43,
  "speaker": "Aran",
  "target_text": "Ci sono tantissime informazioni diverse – noi tendiamo a pensare che una parola sia semplicemente quella cosa lì. Ovviamente non è così, è molto più complicato. Potresti perfino immaginarla come un neurone, ma in realtà è un insieme di neuroni che conservano queste informazioni.",
  "known_text": "",
  "target_audio_id": "trial_8D65341A-EE1E-466D-87B7-8836A9D1FC2F",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:44",
  "scene_number": 2,
  "sentence_number": 44,
  "global_order": 44,
  "speaker": "Aran",
  "target_text": "Quindi quella roba sta lì, e poi ci accediamo in modi diversi. Questo, in sostanza, è semplice, per come capiamo oggi il cervello. Ma se adesso dici: e quali sono le strutture neurologiche che costruiscono uno schema grammaticale?",
  "known_text": "",
  "target_audio_id": "trial_11DA4375-3155-4ABD-BC83-EE80505E8250",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:45",
  "scene_number": 2,
  "sentence_number": 45,
  "global_order": 45,
  "speaker": "Tom",
  "target_text": "È piuttosto complicato.",
  "known_text": "",
  "target_audio_id": "trial_69091C83-18D1-45A9-8F06-7E173B6CD855",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:46",
  "scene_number": 2,
  "sentence_number": 46,
  "global_order": 46,
  "speaker": "Aran",
  "target_text": "Come farebbe a funzionare, poi? Non c'è niente in giro, che io sappia, che dica: questo è il modello, funzionerebbe così. Abbiamo un insieme parallelo di neuroni collegati in modi diversi a queste parole? La cosa parallela è costruita su concetti per tipi di parola? Diventa complicatissimo.",
  "known_text": "",
  "target_audio_id": "trial_9BC5E097-FB41-4E78-B4C1-532A8BF94867",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:47",
  "scene_number": 2,
  "sentence_number": 47,
  "global_order": 47,
  "speaker": "Aran",
  "target_text": "Finisci a dire: ehi, ma come cavolo funziona la grammatica? E la risposta è che, davvero, nessuno lo sa.",
  "known_text": "",
  "target_audio_id": "trial_DC7653A9-DB4D-4BFB-A33E-7B7232477DC6",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:48",
  "scene_number": 2,
  "sentence_number": 48,
  "global_order": 48,
  "speaker": "Aran",
  "target_text": "L'idea stessa di schema grammaticale risale a quattro o cinquecento anni fa, più o meno, tanto per tirare a indovinare, agli inizi dello studio dell'inglese come disciplina accademica, e al modo in cui capivamo l'inglese e la sua grammatica. All'origine è una cosa scolastica. Un pasticcio...",
  "known_text": "",
  "target_audio_id": "trial_1A58149B-F5ED-48C3-9706-923E3B539F67",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:49",
  "scene_number": 2,
  "sentence_number": 49,
  "global_order": 49,
  "speaker": "Aran",
  "target_text": "Tipo: non si può separare l'infinito. Perché non posso separare l'infinito? Perché dovrebbe essere una parola sola, ma quello è il latino. In inglese sono due parole, quindi possiamo separarle. E lo facciamo, le separiamo. Dobbiamo seguire il modello latino? Assolutamente da matti!",
  "known_text": "",
  "target_audio_id": "trial_82A33B1C-5911-4217-86EA-372127080E73",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:50",
  "scene_number": 2,
  "sentence_number": 50,
  "global_order": 50,
  "speaker": "Aran",
  "target_text": "È solo: ok, ci serve questa cosa. La gente sa come usarla, ma noi dobbiamo spiegare che cos'è quello che sanno usare, e codificarlo per poterlo insegnare in modo accademico.",
  "known_text": "",
  "target_audio_id": "trial_B0A74F38-ECC6-43FA-B3EF-60A2C295AF69",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:51",
  "scene_number": 2,
  "sentence_number": 51,
  "global_order": 51,
  "speaker": "Aran",
  "target_text": "E la roba che stiamo facendo lì dentro veniva da un'altra lingua, comunque, e l'abbiamo forzata ad adattarsi in modi che non funzionano. Come tutto questo funzionerebbe nel cervello è – oddio, diventa complicatissimo. È complicato, quindi non può essere così.",
  "known_text": "",
  "target_audio_id": "trial_B017265E-1F33-497D-ABDB-0B9DF8AB3366",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:52",
  "scene_number": 2,
  "sentence_number": 52,
  "global_order": 52,
  "speaker": "Aran",
  "target_text": "Ed è qui che ci stacchiamo radicalmente da quel mondo. Non siamo gli unici a ragionare in questa direzione, ma credo che siamo gli unici a ragionare proprio in questo modo.",
  "known_text": "",
  "target_audio_id": "trial_FDACEBEA-0D90-4834-94D4-5B919AE4DF4D",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:53",
  "scene_number": 2,
  "sentence_number": 53,
  "global_order": 53,
  "speaker": "Aran",
  "target_text": "Poi c'è l'altra area in cui sono appena cominciate le ricerche: i modelli grammaticali, o del parlato, o dell'acquisizione, basati sui sistemi adattivi complessi. Secondo me quelle persone vanno nella direzione giusta, perché penso che in fondo la lingua sia un sistema adattivo complesso.",
  "known_text": "",
  "target_audio_id": "trial_77CB6097-BAC9-4085-BE4B-29077DC04BB5",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:54",
  "scene_number": 2,
  "sentence_number": 54,
  "global_order": 54,
  "speaker": "Aran",
  "target_text": "In gran parte funziona per proprietà emergenti, a partire da condizioni iniziali abbastanza semplici. Ed è lì che ci mettiamo noi. Le persone che lavorano in quell'area, al momento, sembrano concentrarsi soprattutto su come l'interazione linguistica funziona come sistema adattivo complesso.",
  "known_text": "",
  "target_audio_id": "trial_19C07C78-F758-47F4-B425-663893CB1129",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:55",
  "scene_number": 2,
  "sentence_number": 55,
  "global_order": 55,
  "speaker": "Aran",
  "target_text": "Quindi i tuoi schemi d'uso della lingua cambiano un pochino ogni volta che parli con qualcuno. Il tuo modo di parlare adesso porta dentro di sé l'ombra di ogni conversazione che hai avuto prima,",
  "known_text": "",
  "target_audio_id": "trial_99A30890-B3DF-4AED-B303-4F1D7E40588A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:56",
  "scene_number": 2,
  "sentence_number": 56,
  "global_order": 56,
  "speaker": "Tom",
  "target_text": "senza concentrarsi tanto sull'apprendimento in sé e sull'acquisizione.",
  "known_text": "",
  "target_audio_id": "trial_926FE81A-C516-4772-9E4D-09B2990467B9",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:57",
  "scene_number": 2,
  "sentence_number": 57,
  "global_order": 57,
  "speaker": "Aran",
  "target_text": "Esatto. E il modo in cui quello che mi dici tu altera il mio modo di parlare, tutta quella roba, che è interessante, e secondo me stanno facendo qualcosa di importante.",
  "known_text": "",
  "target_audio_id": "trial_48945ABA-EAC6-42B8-8520-E6E83FB4A7B5",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:58",
  "scene_number": 2,
  "sentence_number": 58,
  "global_order": 58,
  "speaker": "Aran",
  "target_text": "Noi invece guardiamo questo: se la lingua è un sistema adattivo complesso, come può questo influire sul modo in cui le persone acquisiscono la lingua?",
  "known_text": "",
  "target_audio_id": "trial_8009475F-24DA-4F07-8EDF-450F898B3943",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:59",
  "scene_number": 2,
  "sentence_number": 59,
  "global_order": 59,
  "speaker": "Aran",
  "target_text": "E quello su cui costruiamo è questa idea di fondo: non hai le parole sotto uno schema grammaticale, hai informazioni singole sulle parole e sui bordi tra le parole. Cioè quali parole si agganciano a quali altre. Se ho appena detto la parola \"red\", qual è la gamma di parole che posso dire dopo?",
  "known_text": "",
  "target_audio_id": "trial_CAAC3CE4-8B89-4AF1-AE92-7B0AC522E55A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:60",
  "scene_number": 2,
  "sentence_number": 60,
  "global_order": 60,
  "speaker": "Aran",
  "target_text": "Posso dire \"red bus\", e lì entra in gioco il riconoscimento di schemi. Ok: \"red\" più qualcosa che somiglia a un autobus, o \"red thing\". Qualunque cosa che somigli a una cosa. Non posso dire \"red going\". Non posso dire \"red went\", e questo si rivela molto utile.",
  "known_text": "",
  "target_audio_id": "trial_2590D9F0-6F49-45F2-B185-8998AEB9969C",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:61",
  "scene_number": 2,
  "sentence_number": 61,
  "global_order": 61,
  "speaker": "Aran",
  "target_text": "Puoi dire certe cose che non ti verrebbero subito in mente...",
  "known_text": "",
  "target_audio_id": "trial_A5794DB4-EDB8-41D0-AE77-FD45B0C45763",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:62",
  "scene_number": 2,
  "sentence_number": 62,
  "global_order": 62,
  "speaker": "Aran",
  "target_text": "Quindi se dicessimo a qualcuno: fammi una lista di tutto quello che può venire dopo \"red\" – un sacco di nomi, e probabilmente quasi solo quelli, ma non puoi, per esempio, dire \"red but\", perché \"red but\" – prendilo come elemento a sé – boh, non vuol dire niente.",
  "known_text": "",
  "target_audio_id": "trial_AA6B172A-55FB-47D8-9FAF-EEE65F3D3673",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:63",
  "scene_number": 2,
  "sentence_number": 63,
  "global_order": 63,
  "speaker": "Aran",
  "target_text": "Ma ovviamente, in mezzo a una conversazione, dici: I'd like one that's red, but I don't mind all that much. Cioè, \"ne vorrei uno rosso, ma non mi importa più di tanto\". Quindi lì c'è un po' di informazione.",
  "known_text": "",
  "target_audio_id": "trial_C0A7BD29-6050-49A2-8DD9-10331D94F2EE",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:64",
  "scene_number": 2,
  "sentence_number": 64,
  "global_order": 64,
  "speaker": "Aran",
  "target_text": "Quello che facciamo allora – ed è stata una botta di fortuna, davvero, per noi – è che la stragrande maggioranza dell'insegnamento tradizionale delle lingue è ricchissima di elementi di vocabolario e ricchissima di regole grammaticali, ma poverissima di esposizione ai bordi.",
  "known_text": "",
  "target_audio_id": "trial_7CC8C9C5-4A31-445A-9D69-4FCE07D8FC8A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:65",
  "scene_number": 2,
  "sentence_number": 65,
  "global_order": 65,
  "speaker": "Aran",
  "target_text": "Quindi tendi a imparare una parola nuova e un paio di contesti in cui puoi usarla, e poi dovresti estrapolare dalla regola grammaticale a qualsiasi altra volta in cui la vuoi usare in un altro contesto, ma quegli altri contesti non ti vengono mostrati in classe, né spesso nella pratica che fai.",
  "known_text": "",
  "target_audio_id": "trial_258E6863-273A-414C-A015-61001952AA4B",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:66",
  "scene_number": 2,
  "sentence_number": 66,
  "global_order": 66,
  "speaker": "Aran",
  "target_text": "Quindi lo si vede – è quasi una cosa visiva – le persone a un certo stadio di sviluppo in una nuova lingua, senti che hanno un sacco di \"ehm\" e \"ah\", e cadono tra una parola e l'altra. Parlano così, con queste piccole... grandi pause.",
  "known_text": "",
  "target_audio_id": "trial_A7C78A90-1BEE-497A-9854-565BAFD98DF5",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:67",
  "scene_number": 2,
  "sentence_number": 67,
  "global_order": 67,
  "speaker": "Aran",
  "target_text": "Invece quando dai alle persone tanta esposizione ai bordi, gli \"ehm\" e gli \"ah\" ci sono ancora, ma a un livello più alto.",
  "known_text": "",
  "target_audio_id": "trial_68AB2754-690E-4475-A57B-4425C87E1F8D",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:68",
  "scene_number": 2,
  "sentence_number": 68,
  "global_order": 68,
  "speaker": "Aran",
  "target_text": "Quindi senti un blocco di parole, poi una piccola pausa, poi quest'altra cosa, perché hanno la flessibilità per cominciare a vedere: ecco i miei blocchi, e poi cominciano semplicemente a raggrupparli. E semplicemente non senti lo stesso tipo di pausa dopo ogni parola.",
  "known_text": "",
  "target_audio_id": "trial_26193ED4-8860-4784-8035-498572ABC8FC",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:69",
  "scene_number": 2,
  "sentence_number": 69,
  "global_order": 69,
  "speaker": "Aran",
  "target_text": "Quindi quello che suggeriamo è che il cervello abbia questi elementi codificati per le parole, ma che poi probabilmente si tratti semplicemente di una catena neurale tra questi blocchi, cioè che questa parola abbia un collegamento neurale.",
  "known_text": "",
  "target_audio_id": "trial_D814D705-FCDC-400C-928E-0F67F6C704A0",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:70",
  "scene_number": 2,
  "sentence_number": 70,
  "global_order": 70,
  "speaker": "Aran",
  "target_text": "È una cosa fisica – ci sono neuroni e sinapsi che portano da questa parola a quella parola, ma non ce ne sono che portano da questa parola a quella che non puoi mai usare dopo di lei. E quando la gente prova a descriverlo come una cosa emotiva, dice: mi suonava giusto.",
  "known_text": "",
  "target_audio_id": "trial_87C023A2-A51C-4757-9E40-C702AE244858",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:71",
  "scene_number": 2,
  "sentence_number": 71,
  "global_order": 71,
  "speaker": "Aran",
  "target_text": "E quello che significa davvero è che non c'erano percorsi neurali che mi portassero a nessun'altra parola lì. Quindi dovevo andare a questa.",
  "known_text": "",
  "target_audio_id": "trial_433E812D-F3ED-45ED-8D03-D7239F854A13",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:72",
  "scene_number": 2,
  "sentence_number": 72,
  "global_order": 72,
  "speaker": "Tom",
  "target_text": "È un po' come con le parole che tendono a stare insieme, che conosciamo per via di citazioni molto frequenti? Per esempio \"to boldly go\": se io dico \"to boldly\", \"go\" – per via di quel bordo che abbiamo creato, ce l'hai come un'unità, che si sente più spesso.",
  "known_text": "",
  "target_audio_id": "trial_F12CB8BF-A788-43FD-BD29-BB68F2D29A14",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:73",
  "scene_number": 2,
  "sentence_number": 73,
  "global_order": 73,
  "speaker": "Tom",
  "target_text": "Certe parole stanno insieme davvero, anche se non c'è nessun motivo perché stiano insieme, solo per l'uso.",
  "known_text": "",
  "target_audio_id": "trial_A1C6F9D3-6A74-4E00-98E6-88EEFFEF1141",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:74",
  "scene_number": 2,
  "sentence_number": 74,
  "global_order": 74,
  "speaker": "Aran",
  "target_text": "Qui stai entrando – ed è un'altra cosa che non è davvero centrale nella maggior parte delle metodologie di acquisizione delle lingue – stai entrando nel campo di alcuni lavori solidissimi e geniali sulla memoria. Ora, la memoria è un tuo grande interesse.",
  "known_text": "",
  "target_audio_id": "trial_74796E1E-B3B3-4B48-A12D-C5040066AE80",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:75",
  "scene_number": 2,
  "sentence_number": 75,
  "global_order": 75,
  "speaker": "Aran",
  "target_text": "E poi è una cosa molto più vicina alla scatola nera della neuroplasticità. Gran parte di quello che succede con la memoria è: cosa succede a livello sinaptico? Quali sono i neurotrasmettitori? Quali sono le cariche chimiche? Cosa possiamo misurare esattamente qui?",
  "known_text": "",
  "target_audio_id": "trial_D9A6AF43-BD1B-4184-9844-E7B9981B6CCE",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:76",
  "scene_number": 2,
  "sentence_number": 76,
  "global_order": 76,
  "speaker": "Aran",
  "target_text": "Possiamo misurare gli effetti di attenuazione oltre a quelli di aumento? Il lavoro fatto sulla memoria negli ultimi 40-50 anni è dettagliatissimo. Ed è un peccato, secondo me, per certi versi, che in termini di",
  "known_text": "",
  "target_audio_id": "trial_39DB2E78-43B9-4FF3-A15C-1F8984E62121",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:77",
  "scene_number": 2,
  "sentence_number": 77,
  "global_order": 77,
  "speaker": "Tom",
  "target_text": "Non è stato applicato molto all'acquisizione delle lingue.",
  "known_text": "",
  "target_audio_id": "trial_D2113E2D-1A0C-40A4-A43E-8626F795D636",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:78",
  "scene_number": 2,
  "sentence_number": 78,
  "global_order": 78,
  "speaker": "Aran",
  "target_text": "Ma poi la memoria – se ne leggi sui giornali, di solito si parla solo di trucchi per ricordare.",
  "known_text": "",
  "target_audio_id": "trial_37EA1152-5C08-48FC-91FA-C93A354DC397",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:79",
  "scene_number": 2,
  "sentence_number": 79,
  "global_order": 79,
  "speaker": "Tom",
  "target_text": "Che non c'è niente di male, ma è tutto abbastanza slegato dall'utilità della memoria. Avere una buona memoria, e una buona memoria di lavoro e a breve termine – tutte queste cose sono utilissime nell'apprendimento di tutti i giorni, nella conversazione.",
  "known_text": "",
  "target_audio_id": "trial_42E75999-674F-4AA0-B96E-F46EEADE2B21",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:80",
  "scene_number": 2,
  "sentence_number": 80,
  "global_order": 80,
  "speaker": "Aran",
  "target_text": "Sui giornali suona un po' come fumo e specchi: \"Ah, c'è questo tizio che ha imparato il pi greco fino a cento cifre\", e probabilmente lì dietro c'è un po' di fumo e specchi.",
  "known_text": "",
  "target_audio_id": "trial_2A894723-FEEB-46EB-801A-D8527BAD5F8C",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:81",
  "scene_number": 2,
  "sentence_number": 81,
  "global_order": 81,
  "speaker": "Aran",
  "target_text": "E si parla pochissimo, in pubblico, di quanto sia incredibilmente dettagliata la nostra comprensione di certi processi della memoria, e di quelli che invece non capiamo ancora.",
  "known_text": "",
  "target_audio_id": "trial_9C26B84A-8A0B-4597-93B5-0336F050C0F4",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:82",
  "scene_number": 2,
  "sentence_number": 82,
  "global_order": 82,
  "speaker": "Aran",
  "target_text": "Quindi quando cominci a parlare di come formiamo questi collegamenti tra le parole, la ricerca semplice sulla memoria dice: rispondiamo all'esposizione. C'è un tipo di ricordi che non hanno bisogno di nessuna ripetizione, la roba fortemente emotiva.",
  "known_text": "",
  "target_audio_id": "trial_32292634-E311-4F30-86D7-369B83C2D9F4",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:83",
  "scene_number": 2,
  "sentence_number": 83,
  "global_order": 83,
  "speaker": "Aran",
  "target_text": "Non ti ricordi la cosa più imbarazzante che ti sia mai successa perché ti sei messo lì a ripassarla – è perché non hai fatto abbastanza terapia per liberarti del trauma, e resterà lì per sempre!",
  "known_text": "",
  "target_audio_id": "trial_4332CD9E-CCF6-4339-B1CB-ECAE3951D525",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:84",
  "scene_number": 2,
  "sentence_number": 84,
  "global_order": 84,
  "speaker": "Aran",
  "target_text": "Ma per la maggior parte delle cose, per tutto quello che riguarda le informazioni e l'acquisizione di informazioni, è l'esposizione. È soprattutto una combinazione di frequenza e di quanto è recente. Quindi quando dici \"to boldly...\" e mi chiedi di indovinare la parola dopo, dirò \"go\".",
  "known_text": "",
  "target_audio_id": "trial_DB59694D-6BCD-4C53-9D77-23091E3D5D66",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:85",
  "scene_number": 2,
  "sentence_number": 85,
  "global_order": 85,
  "speaker": "Aran",
  "target_text": "Ma non lo dico perché ho visto una puntata di Star Trek. Lo dico perché lo senti di continuo. Viene citato, ci sono più puntate. E lo si usa come esempio di quando separare l'infinito è in realtà una cosa molto utile da fare per dare enfasi... Frequenza enorme, enorme, enorme.",
  "known_text": "",
  "target_audio_id": "trial_E034AC7B-124C-40C2-8DEF-3600019DB508",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:86",
  "scene_number": 2,
  "sentence_number": 86,
  "global_order": 86,
  "speaker": "Aran",
  "target_text": "Ed è uno dei modi in cui ogni singola conversazione incide sul tuo uso della lingua. Non so bene perché ho usato quella struttura un paio di volte qui, e potrebbero esserci un mucchio di motivi: l'ho detta di recente. Magari l'hai detta tu prima, nella conversazione,",
  "known_text": "",
  "target_audio_id": "trial_38BACACD-5E8C-423C-90DB-09B708407A3A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:87",
  "scene_number": 2,
  "sentence_number": 87,
  "global_order": 87,
  "speaker": "Tom",
  "target_text": "Quindi c'è un'etichetta della conversazione – un riflesso, che è il sistema adattivo complesso – quando parli con certe persone che usano parole più corte, tendi ad accorciare le tue. Oppure se sei in un contesto accademico, tenderai a usare frasi più elaborate.",
  "known_text": "",
  "target_audio_id": "trial_046DDD4C-89E1-4ACB-A8FF-8C669E20E360",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:88",
  "scene_number": 2,
  "sentence_number": 88,
  "global_order": 88,
  "speaker": "Aran",
  "target_text": "E poi c'è anche la semplice matematica. Hai appena detto \"contesto accademico\". Non è una cosa che non avevo mai sentito. L'avevo già sentita. Ora l'ho sentita più spesso di prima.",
  "known_text": "",
  "target_audio_id": "trial_520FA76D-1959-4109-A0BA-66D738934DD7",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:89",
  "scene_number": 2,
  "sentence_number": 89,
  "global_order": 89,
  "speaker": "Aran",
  "target_text": "Quindi la prossima volta che sentirò la parola \"accademico\", il mio cervello si preparerà un infinitesimale, minuscolo pochino di più di quanto avrebbe fatto prima. Senti \"contesto\" da solo e pensi: ah, \"contesto\" è collegato a \"contesto accademico\".",
  "known_text": "",
  "target_audio_id": "trial_61F4D58C-E25A-4E9F-A489-D2417C76655B",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:90",
  "scene_number": 2,
  "sentence_number": 90,
  "global_order": 90,
  "speaker": "Tom",
  "target_text": "E questa cosa mi affascina anche – la capacità degli esseri umani di fare collegamenti tra le cose, e poi di spezzare le cose...",
  "known_text": "",
  "target_audio_id": "trial_38EF4D02-FE43-447A-888A-6F11A24048FB",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:91",
  "scene_number": 2,
  "sentence_number": 91,
  "global_order": 91,
  "speaker": "Tom",
  "target_text": "Mi è venuta in mente una cosa mentre parlavi: come le parole stesse possono contenere un sacco di significati che, quando le smontiamo, ci fanno dire: ah, che interessante. Per esempio \"listless\" – diciamo spesso che le cose sono \"listless\", cioè fiacche, senza energia.",
  "known_text": "",
  "target_audio_id": "trial_ADF34788-9DFC-47D7-8BAD-71DEB0F59782",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:92",
  "scene_number": 2,
  "sentence_number": 92,
  "global_order": 92,
  "speaker": "Tom",
  "target_text": "Non parliamo spesso di \"list\" da solo. Quindi ci sono direzioni in cui le parole stesse ti portano. Se torni un po' indietro e ti chiedi: quali sono i componenti che formano questa cosa – perché \"listless\" è una parola? Perché non sono due parole?",
  "known_text": "",
  "target_audio_id": "trial_3EA4CEC2-C17B-4C72-AF24-191424605E21",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:93",
  "scene_number": 2,
  "sentence_number": 93,
  "global_order": 93,
  "speaker": "Tom",
  "target_text": "Perché in realtà sono due, quelle che chiameremmo sillabe. La maggior parte delle persone individua onde sonore che si possono spezzare più o meno in due componenti che partono e si fermano. Quindi le ascoltiamo come sillabe. Ma è piuttosto interessante, no? \"List\", da solo. \"Less\" è una parola.",
  "known_text": "",
  "target_audio_id": "trial_025984B1-AB36-465D-98A3-CEC9E2197177",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:94",
  "scene_number": 2,
  "sentence_number": 94,
  "global_order": 94,
  "speaker": "Tom",
  "target_text": "\"Listless\" lo usiamo... E tutta questa idea di quando una parola ha un significato, e quando ha un contesto suo?",
  "known_text": "",
  "target_audio_id": "trial_81F04AFE-B078-481B-B6A0-B4CADBF97FD5",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:95",
  "scene_number": 3,
  "sentence_number": 95,
  "global_order": 95,
  "speaker": "Aran",
  "target_text": "C'è una ricercatrice molto stimata, Alison Wray, la cui specialità – quello per cui è conosciuta soprattutto – è il lavoro sul linguaggio formulaico.",
  "known_text": "",
  "target_audio_id": "trial_36E98476-B7F4-4F7C-80F1-975FE7A019A6",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:96",
  "scene_number": 3,
  "sentence_number": 96,
  "global_order": 96,
  "speaker": "Aran",
  "target_text": "E una delle cose che ha cominciato a suggerire, almeno nelle conversazioni – non so se l'abbia già pubblicato – è questa: non esiste una cosa come \"una parola\". Non ce ne sono.",
  "known_text": "",
  "target_audio_id": "trial_F20F8871-2B4B-4CF7-9E6F-E57361ED4BCA",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:97",
  "scene_number": 3,
  "sentence_number": 97,
  "global_order": 97,
  "speaker": "Aran",
  "target_text": "Usiamo il termine per indicare qualcosa che in realtà non esiste, ed è semplicemente un modo poco utile di scomporre le cose. E ogni volta che l'ho sentita dirlo ho pensato: sì. Ok, non credo di riuscire a starti dietro – mi sta già scoppiando il cervello.",
  "known_text": "",
  "target_audio_id": "trial_4EF3B362-FFF9-4824-9EB9-1E4DF000D499",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:98",
  "scene_number": 3,
  "sentence_number": 98,
  "global_order": 98,
  "speaker": "Tom",
  "target_text": "Probabilmente lei direbbe che la sillaba esiste, o che esiste il suono. E poi ci sono i modi in cui queste unità di suono, che partono e si fermano, vengono messe insieme, che magari noi...",
  "known_text": "",
  "target_audio_id": "trial_D57D72E5-C139-4C85-8DDE-CB390AEEDD4C",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:99",
  "scene_number": 3,
  "sentence_number": 99,
  "global_order": 99,
  "speaker": "Aran",
  "target_text": "Quindi lei direbbe, per esempio – senza pensarci troppo, noi diremmo sicuramente che \"to boldly go\" sono tre parole, ma in realtà, in molti dei modi in cui potresti provare a definire che cos'è una parola, \"to boldly go\" è una parola sola. E poi cadi nel misticismo...",
  "known_text": "",
  "target_audio_id": "trial_972AD8F7-0D09-4AA7-9178-8346D0B56DF0",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:100",
  "scene_number": 3,
  "sentence_number": 100,
  "global_order": 100,
  "speaker": "Tom",
  "target_text": "Perché è un'unità di significato a sé stante, no...",
  "known_text": "",
  "target_audio_id": "trial_621C1424-4B7F-45D2-BB73-ED6B19033FEA",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:101",
  "scene_number": 3,
  "sentence_number": 101,
  "global_order": 101,
  "speaker": "Aran",
  "target_text": "C'è un'altra cosa riguardo a questi percorsi neurali.",
  "known_text": "",
  "target_audio_id": "trial_231DE692-E9BE-4BEC-894D-EB39EE618BB5",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:102",
  "scene_number": 3,
  "sentence_number": 102,
  "global_order": 102,
  "speaker": "Aran",
  "target_text": "Se stiamo solo costruendo gruppi neurali per l'informazione semantica – chiamiamole parole, anche se non esistono – e costruendo i bordi, i collegamenti neurali tra quei gruppi: se facciamo solo questo, è già abbastanza per creare comportamento emergente. Ma adesso c'è un'altra cosa affascinante.",
  "known_text": "",
  "target_audio_id": "trial_A6ECAF2A-B677-4A65-BC49-9B05AEE75DF7",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:103",
  "scene_number": 3,
  "sentence_number": 103,
  "global_order": 103,
  "speaker": "Aran",
  "target_text": "Se dai a qualcuno – ed è l'apprendimento molto tradizionale – un insieme di gruppi neurali. Peccato che le registrazioni non possano cogliere i miei patetici tentativi di mimarlo, vero?",
  "known_text": "",
  "target_audio_id": "trial_434A8A27-4D81-4E37-8262-3396B79F4D33",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:104",
  "scene_number": 3,
  "sentence_number": 104,
  "global_order": 104,
  "speaker": "Tom",
  "target_text": "Credo che capiranno – sta battendo sul bracciolo della sedia, cercando di mostrare elementi distinti, accoppiati, parole o sillabe.",
  "known_text": "",
  "target_audio_id": "trial_76C69891-AA03-4DDD-8AA7-98183A1CB5E5",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:105",
  "scene_number": 3,
  "sentence_number": 105,
  "global_order": 105,
  "speaker": "Aran",
  "target_text": "Allora, immagina di avere questa fila di gruppi neurali qui, e di avere un collegamento tra ognuno di loro. Quindi questo è il classico ambiente ricco di elementi di vocabolario e povero di bordi. Quindi tutto quello che possiamo fare qui è partire da lì e arrivare fin là.",
  "known_text": "",
  "target_audio_id": "trial_986A9DCE-9BD0-42AE-99AD-45BDA17C1DF8",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:106",
  "scene_number": 3,
  "sentence_number": 106,
  "global_order": 106,
  "speaker": "Tom",
  "target_text": "Non abbiamo la rete.",
  "known_text": "",
  "target_audio_id": "trial_8DEF0D05-F705-4CD3-B13B-2E06462CFC1F",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:107",
  "scene_number": 3,
  "sentence_number": 107,
  "global_order": 107,
  "speaker": "Aran",
  "target_text": "E questo è noioso – è proprio noiosissimo. Ma se adesso lo ampliamo, quindi abbiamo questo strato e questo e quest'altro. Quindi non un numero enorme di elementi di vocabolario – diciamo che li triplichiamo. Diciamo che qui ne abbiamo cinque.",
  "known_text": "",
  "target_audio_id": "trial_D4F02BFF-517F-4633-B012-99130A867936",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:108",
  "scene_number": 3,
  "sentence_number": 108,
  "global_order": 108,
  "speaker": "Aran",
  "target_text": "Adesso siamo a 15, ma ora aggiungiamo tutti i collegamenti possibili tra loro. Quindi adesso posso partire da qui e passare di qua in un sacco di modi diversi, ed è giocoso. E a quel punto l'adulto che impara pensa: ah, posso dire un sacco di cose diverse. Che bello.",
  "known_text": "",
  "target_audio_id": "trial_8050BB5D-2D95-4D1E-B398-EAC5CD74DAD1",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:109",
  "scene_number": 3,
  "sentence_number": 109,
  "global_order": 109,
  "speaker": "Aran",
  "target_text": "Sto prendendo il controllo di questo processo. Mi sto divertendo. Sto giocando. Sto facendo cose intelligenti.",
  "known_text": "",
  "target_audio_id": "trial_1313677F-24E2-4B93-AAFE-D4BA0CEA152F",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:110",
  "scene_number": 4,
  "sentence_number": 110,
  "global_order": 110,
  "speaker": "Tom",
  "target_text": "Allora, su questa scia – il modo in cui presento il tuo metodo alle persone è questo: dico, ok, ti porto in un contesto – è una lezione di teatro. Stai facendo un gioco di riscaldamento. E il gioco si chiama \"Holy Dickhead Batman\". Holy Dickhead Batman.",
  "known_text": "",
  "target_audio_id": "trial_9EA6F6EB-0490-49EA-BE0A-B22B99B3A9E2",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:111",
  "scene_number": 4,
  "sentence_number": 111,
  "global_order": 111,
  "speaker": "Tom",
  "target_text": "E l'idea è che tutti sparano più combinazioni casuali possibili di quella frase. Holy BatHead, ManDick, Holy DickMan, Bathead, Holy HeadDick ManBat, e così via.",
  "known_text": "",
  "target_audio_id": "trial_DDB61C51-9ED8-4F84-8B08-1DA3582491D3",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:112",
  "scene_number": 4,
  "sentence_number": 112,
  "global_order": 112,
  "speaker": "Tom",
  "target_text": "Ed è divertente perché è giocoso, e fa vedere come puoi far lavorare per te le parole o le unità di significato, se le impari come queste unità minime di significato, e poi ci giochi,",
  "known_text": "",
  "target_audio_id": "trial_9625FC70-1CED-48FF-8DD9-67BEACAAEAEE",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:113",
  "scene_number": 4,
  "sentence_number": 113,
  "global_order": 113,
  "speaker": "Aran",
  "target_text": "e dando alle persone il permesso di giocarci, perché anche se l'ordine poi non porta a un vero atto di comunicazione, va bene lo stesso. Quindi giocaci e basta. E poi quando giochi e ti esce qualcosa che fa scattare un atto di comunicazione, ricevi il riscontro: ah, ha funzionato.",
  "known_text": "",
  "target_audio_id": "trial_FA3AA119-848F-4574-BFB9-6E51F464A848",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:114",
  "scene_number": 4,
  "sentence_number": 114,
  "global_order": 114,
  "speaker": "Tom",
  "target_text": "Tutto scatta insieme. Come La vendetta dei Sith.",
  "known_text": "",
  "target_audio_id": "trial_DEDD305B-1F71-48FE-AFE3-70558E60A09D",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:115",
  "scene_number": 4,
  "sentence_number": 115,
  "global_order": 115,
  "speaker": "Aran",
  "target_text": "Sì, in un certo senso. È l'elemento curativo rispetto agli approcci tradizionali.",
  "known_text": "",
  "target_audio_id": "trial_A95A2FD4-04D9-4EDB-BD28-4E070D2E618E",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:116",
  "scene_number": 4,
  "sentence_number": 116,
  "global_order": 116,
  "speaker": "Aran",
  "target_text": "Quindi quello che succede è che tradizionalmente le persone passano, in qualunque modo le portino a farlo – acquisiscono vocabolario, e acquisiscono una specie di schema grammaticale, che dovrebbe dare loro un insieme di regole",
  "known_text": "",
  "target_audio_id": "trial_E1220EAF-B452-473D-BED5-159ACD119A08",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:117",
  "scene_number": 4,
  "sentence_number": 117,
  "global_order": 117,
  "speaker": "Tom",
  "target_text": "così le unità di vocabolario si possono mettere insieme e trasmettere una specie di significato,",
  "known_text": "",
  "target_audio_id": "trial_73CDDD50-4ACE-42CF-A4F2-DB80BD50E8B2",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:118",
  "scene_number": 4,
  "sentence_number": 118,
  "global_order": 118,
  "speaker": "Aran",
  "target_text": "e poi li porti al punto in cui: \"ecco una persona che parla quella lingua, devi provare a comunicare con lei\". Quando chiedi alla stragrande maggioranza degli insegnanti di lingue: ok, adesso sono intermedio avanzato, come faccio ad arrivare a parlare fluentemente?",
  "known_text": "",
  "target_audio_id": "trial_735D8234-648C-44CB-B8AD-A1E7A7ABC73F",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:119",
  "scene_number": 4,
  "sentence_number": 119,
  "global_order": 119,
  "speaker": "Aran",
  "target_text": "Ti diranno: pratica, vai a usarla, ascolta un sacco di radio e televisione e parla con un sacco di gente. Ed è vero. È quello che devi fare, ma è durissima se non ti sei preparato.",
  "known_text": "",
  "target_audio_id": "trial_FA5C1EC9-599A-4524-A0B5-3293134A0D4F",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:120",
  "scene_number": 4,
  "sentence_number": 120,
  "global_order": 120,
  "speaker": "Aran",
  "target_text": "Se tutto quello che hai sono elementi di vocabolario e un insieme di regole, entri in quell'ambiente dove devi cominciare a creare tu le tue frasi per vedere se funzionano o no. Ora, se lì ti incoraggiano a essere giocoso, quel processo diventa molto meno doloroso.",
  "known_text": "",
  "target_audio_id": "trial_C131CD18-E5A3-4E9D-987E-3F90A9C0EDD8",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:121",
  "scene_number": 4,
  "sentence_number": 121,
  "global_order": 121,
  "speaker": "Aran",
  "target_text": "Ma se, prima di arrivare a quello stadio, sei già stato allenato a percorrere un sacco di percorsi diversi, allora non è più un salto. È solo più della stessa roba – continui a fare quello che facevi. Quindi poi il discorso è: quando i tuoi livelli di esposizione arrivano qui, ti senti a posto.",
  "known_text": "",
  "target_audio_id": "trial_C170D931-8613-440E-8FE5-0B835B820E01",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:122",
  "scene_number": 4,
  "sentence_number": 122,
  "global_order": 122,
  "speaker": "Aran",
  "target_text": "Quindi, quella cosa che dicevi un bel po' fa...",
  "known_text": "",
  "target_audio_id": "trial_177C4A5B-B2BE-4E62-8FF8-5DF101DBD999",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:123",
  "scene_number": 4,
  "sentence_number": 123,
  "global_order": 123,
  "speaker": "Tom",
  "target_text": "Ritornando alla tua roba, e a come è diversa, e al machine learning e tutta quella roba lì.",
  "known_text": "",
  "target_audio_id": "trial_D34E374A-50BC-49AC-8723-1BB361694237",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:124",
  "scene_number": 4,
  "sentence_number": 124,
  "global_order": 124,
  "speaker": "Aran",
  "target_text": "Prendiamo una persona che va a un corso serale, quindi ci va una o due volte a settimana, due ore di corso serale, per imparare una lingua. E in quel corso serale ci sarà un mix di nuovi elementi di vocabolario che vengono presentati.",
  "known_text": "",
  "target_audio_id": "trial_EA748687-3D13-45B1-BF71-29084D2F00A7",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:125",
  "scene_number": 4,
  "sentence_number": 125,
  "global_order": 125,
  "speaker": "Aran",
  "target_text": "Se sei fortunato, ci sarà qualche gioco, magari qualche piccolo gioco di ruolo, girando per la classe. E ci saranno le coniugazioni e roba del genere.",
  "known_text": "",
  "target_audio_id": "trial_9C343120-8605-4481-8B22-34BB6F7EEBF4",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:126",
  "scene_number": 4,
  "sentence_number": 126,
  "global_order": 126,
  "speaker": "Aran",
  "target_text": "Quindi, a grandi linee, ci saranno parole, ci sarà lo schema grammaticale, e poi magari, con i migliori insegnanti, ci sarà una specie di ambiente non troppo formale in cui provare a usare alcune di queste cose. Il modello standard qui è: è un modo incredibilmente lento di acquisire una lingua.",
  "known_text": "",
  "target_audio_id": "trial_A289A3B9-B360-4B94-9B6C-62B588CB0BE9",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:127",
  "scene_number": 4,
  "sentence_number": 127,
  "global_order": 127,
  "speaker": "Aran",
  "target_text": "Ci vuole un sacco di tempo. Se vai a un corso serale due volte a settimana, ci vorranno dai cinque ai dieci anni prima di fare delle vere belle conversazioni, e succederà a tutti gli altri, quindi penserai che sia normale e che vada bene. Che sia così. Che sia una faticaccia.",
  "known_text": "",
  "target_audio_id": "trial_DA8B0826-C201-4483-AB73-BDDDD771AB21",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:128",
  "scene_number": 4,
  "sentence_number": 128,
  "global_order": 128,
  "speaker": "Tom",
  "target_text": "È così che si impara una lingua da adulti.",
  "known_text": "",
  "target_audio_id": "trial_2F254739-6C6B-47E5-9500-B4E819218E7C",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:129",
  "scene_number": 4,
  "sentence_number": 129,
  "global_order": 129,
  "speaker": "Aran",
  "target_text": "Esatto. Una delle cose che succedono lì è che, per via dell'attenzione sullo schema grammaticale, c'è molta meno ripetizione dei nuovi elementi di vocabolario. E ovviamente hai quell'ambiente meno ricco dei bordi tra le parole.",
  "known_text": "",
  "target_audio_id": "trial_89016E93-520C-46E9-8543-CD7FE08AA9A8",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:130",
  "scene_number": 4,
  "sentence_number": 130,
  "global_order": 130,
  "speaker": "Aran",
  "target_text": "Quindi sei corto di bordi, ma sei corto anche di ripetizione degli elementi di vocabolario. Quindi quando torni la settimana dopo ne hai dimenticati la maggior parte, e spesso, invece di tornare indietro a fare il ripasso, vai avanti con un mucchio di roba nuova.",
  "known_text": "",
  "target_audio_id": "trial_04E09AFF-7F20-4BCA-A32B-EC93044AD4DC",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:131",
  "scene_number": 4,
  "sentence_number": 131,
  "global_order": 131,
  "speaker": "Aran",
  "target_text": "E in molti casi, a parte gli insegnanti davvero bravi, che capiscono di dover aiutare nel processo di costruzione dei ricordi, ci sono persone che hanno un programma da seguire – che fanno tutta questa roba nella settimana uno, ignorano il fatto che sia stata dimenticata già alla settimana due,",
  "known_text": "",
  "target_audio_id": "trial_94B588DB-51C2-4049-B080-F0E0D0F4B418",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:132",
  "scene_number": 4,
  "sentence_number": 132,
  "global_order": 132,
  "speaker": "Aran",
  "target_text": "fanno tutta la roba nuova nella settimana due, ignorano il fatto che sia stata dimenticata, fanno tutta la roba nuova nella settimana tre. E quello che succede è che quei primi ricordi diventano funzionali solo di rado, quando capita un'occasione, in gran parte a caso, per rinforzarli più avanti.",
  "known_text": "",
  "target_audio_id": "trial_3418590B-AE88-4C24-A758-92487C2568E6",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:133",
  "scene_number": 4,
  "sentence_number": 133,
  "global_order": 133,
  "speaker": "Aran",
  "target_text": "La stragrande maggioranza dei programmi semplicemente non dà un'attenzione significativa alla ripetizione dilazionata. Non pensano: ah, a questo punto dobbiamo tornare a rivedere tutta quella roba. È solo: dovevi averla imparata – era il tuo compito a casa.",
  "known_text": "",
  "target_audio_id": "trial_A0026941-BA10-4BA0-8341-37ABCA9D405A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:134",
  "scene_number": 4,
  "sentence_number": 134,
  "global_order": 134,
  "speaker": "Aran",
  "target_text": "Assicurati di averla imparata per i compiti. Ma se lo dici a persone che non sono specialisti della memoria, come dovrebbero impararla?",
  "known_text": "",
  "target_audio_id": "trial_C632742E-1A6A-4656-8FB7-C2DA832CB6C8",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:135",
  "scene_number": 4,
  "sentence_number": 135,
  "global_order": 135,
  "speaker": "Aran",
  "target_text": "Una delle cose che si vedono molto spesso, e che mi spezzano il cuore – le vedi nelle scuole dappertutto: vedi ragazzi a cui importa davvero e che ce la mettono tutta, e vedi i loro quaderni, pieni di quel cazzo di evidenziatore!",
  "known_text": "",
  "target_audio_id": "trial_82F545BF-878F-4F43-B84E-7CE57DF20589",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:136",
  "scene_number": 4,
  "sentence_number": 136,
  "global_order": 136,
  "speaker": "Aran",
  "target_text": "E i risultati sono chiari: non fa nessuna differenza, evidenziare, ripassare un testo. Peggio di zero – ti fa perdere tempo",
  "known_text": "",
  "target_audio_id": "trial_2B7DF880-1FC9-48D4-AF0E-86CFD0CB7A9C",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:137",
  "scene_number": 4,
  "sentence_number": 137,
  "global_order": 137,
  "speaker": "Tom",
  "target_text": "e non produce nessun valore.",
  "known_text": "",
  "target_audio_id": "trial_9AB0A32F-7034-4A9D-9423-5AF769FCFE68",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:138",
  "scene_number": 4,
  "sentence_number": 138,
  "global_order": 138,
  "speaker": "Aran",
  "target_text": "Gli è stato detto: vai a impararlo. Siccome non sono specialisti della memoria, non sanno come impararlo, ma a un certo punto qualcuno gli ha detto: evidenzia, oppure l'hanno visto fare a qualcun altro. Magari era solo un fratello o una sorella più grande.",
  "known_text": "",
  "target_audio_id": "trial_74416186-28F9-4C1E-BA66-648B96BC60E8",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:139",
  "scene_number": 4,
  "sentence_number": 139,
  "global_order": 139,
  "speaker": "Aran",
  "target_text": "Quindi vanno a evidenziare e si fanno il mazzo. Cercano di farla funzionare. E fanno una cosa che è dimostrato non fare differenza, e noi li stiamo deludendo. In modo devastante.",
  "known_text": "",
  "target_audio_id": "trial_95DD5370-4C46-49C7-93B2-AF3FF8AE2B9A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:140",
  "scene_number": 4,
  "sentence_number": 140,
  "global_order": 140,
  "speaker": "Aran",
  "target_text": "È una nostra responsabilità, come generazione che ci è passata, riuscire a dire: ah, guarda, ecco come si forma un ricordo. Se fai queste cose, poi te lo ricordi. E non lo stiamo facendo.",
  "known_text": "",
  "target_audio_id": "trial_6CF7745D-0007-46F8-8DD4-57D8A6155033",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:141",
  "scene_number": 4,
  "sentence_number": 141,
  "global_order": 141,
  "speaker": "Aran",
  "target_text": "E la stragrande maggioranza degli insegnanti, ovviamente, non sono specialisti della memoria, quindi non sono consapevoli di queste cose, e fanno quello che hanno visto fare agli altri. Un fallimento sistemico gigantesco.",
  "known_text": "",
  "target_audio_id": "trial_2308231B-2885-414D-9B47-E6C05F5F3D13",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:142",
  "scene_number": 5,
  "sentence_number": 142,
  "global_order": 142,
  "speaker": "Tom",
  "target_text": "Ci sono un sacco di cose che voglio approfondire lì dentro, prima o poi, ma restiamo sulla ripetizione dilazionata, visto che l'hai tirata fuori. Penso che la maggior parte di quelli che ci ascoltano sappia cos'è, ma parliamo della ripetizione dilazionata nella metodologia.",
  "known_text": "",
  "target_audio_id": "trial_25A6D914-0E51-4406-9969-36CAA4ECE00A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:143",
  "scene_number": 5,
  "sentence_number": 143,
  "global_order": 143,
  "speaker": "Tom",
  "target_text": "Come ci sei inciampato TU? E perché era così importante per te? Quando hai capito quanto era importante, in che misura lo è, e come fai a decidere ogni quanto ripetere le cose? C'è parecchia roba lì dentro.",
  "known_text": "",
  "target_audio_id": "trial_F2DEF711-0BEE-48EE-8BDB-29DBD41309D7",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:144",
  "scene_number": 5,
  "sentence_number": 144,
  "global_order": 144,
  "speaker": "Aran",
  "target_text": "Non c'è niente di nuovo o di magico nella ripetizione dilazionata. È una cosa capita benissimo. Non so se sia capita del tutto, ma è assodata – un fenomeno noto e dimostrato efficace.",
  "known_text": "",
  "target_audio_id": "trial_31A37433-BDD3-4F50-8B7A-106699FDE5B7",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:145",
  "scene_number": 5,
  "sentence_number": 145,
  "global_order": 145,
  "speaker": "Aran",
  "target_text": "Nell'acquisizione delle lingue, una delle prime persone a pensarci e a scriverne è stato Paul Pimsleur, e i due corsi che ha scritto – ne ha scritti solo due prima di morire – hanno la ripetizione dilazionata incorporata. Ed è stato molto bravo.",
  "known_text": "",
  "target_audio_id": "trial_0CE08C53-3C64-400F-A5A2-8AC355C202CB",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:146",
  "scene_number": 5,
  "sentence_number": 146,
  "global_order": 146,
  "speaker": "Aran",
  "target_text": "Credo che abbia fatto un errore interessante, un errore interessante e non ovvio. Quello che diceva era: le ripetizioni multiple perdono utilità in modo drastico, e questo ora è confermato da ricerche più recenti nel campo. Diceva che vuoi riprendere la parola poco prima di dimenticarla.",
  "known_text": "",
  "target_audio_id": "trial_F2487993-875E-4EDE-9CAD-420E8956C296",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:147",
  "scene_number": 5,
  "sentence_number": 147,
  "global_order": 147,
  "speaker": "Aran",
  "target_text": "Ora, quando la dimenticherai? È difficile da capire, ma quello che possiamo fare è una specie di stima del tempo di dimezzamento,",
  "known_text": "",
  "target_audio_id": "trial_551AAC9F-7A3B-4E12-8207-873739B34AF0",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:148",
  "scene_number": 5,
  "sentence_number": 148,
  "global_order": 148,
  "speaker": "Tom",
  "target_text": "basata su studenti medi.",
  "known_text": "",
  "target_audio_id": "trial_4CBBFB85-78C6-487B-8150-7B9A157539BA",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:149",
  "scene_number": 5,
  "sentence_number": 149,
  "global_order": 149,
  "speaker": "Aran",
  "target_text": "Puoi dare a delle persone un mucchio di lavoro per imparare un po' di vocabolario, testarle su quel vocabolario un mese dopo e vedere quante parole si ricordano ancora, mesi dopo, e così via. Devi stare un po' attento.",
  "known_text": "",
  "target_audio_id": "trial_56E16688-79BB-4C64-A49D-67E132E05471",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:150",
  "scene_number": 5,
  "sentence_number": 150,
  "global_order": 150,
  "speaker": "Aran",
  "target_text": "Ti servono davvero gruppi che vengono testati dopo un mese, gruppi che vengono testati dopo due mesi – altrimenti gli stai dando la ripetizione dilazionata. Ma si può fare. E poi puoi farti un'idea che dice: ok, in generale, dopo il primo lavoro, si perderà più o meno a questo punto.",
  "known_text": "",
  "target_audio_id": "trial_99D33BA6-F5B7-4505-8F1D-BCD5416545D9",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:151",
  "scene_number": 5,
  "sentence_number": 151,
  "global_order": 151,
  "speaker": "Aran",
  "target_text": "Quindi ripassiamolo poco prima. Giusto. Ora, c'è un difetto in questo.",
  "known_text": "",
  "target_audio_id": "trial_33B89CB9-0FD3-45FD-8AB3-F6EB27CE2FEF",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:152",
  "scene_number": 5,
  "sentence_number": 152,
  "global_order": 152,
  "speaker": "Tom",
  "target_text": "Ebbinghaus è stato il tizio che ha inventato originariamente 'ste cose, vero? Il lavoro iniziale, il tedesco, e lui si basa su una sola serie di cose a caso che ha memorizzato da solo.",
  "known_text": "",
  "target_audio_id": "trial_0B2650F6-98F9-4B26-8B56-A089C5BF221C",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:153",
  "scene_number": 5,
  "sentence_number": 153,
  "global_order": 153,
  "speaker": "Tom",
  "target_text": "Come si dice spesso, il problema è il campione: c'era solo lui, e nessun altro a confermarlo. Tutti continuano a citare i suoi dati iniziali su questi tempi ottimali. Comunque, la tecnica ha dimostrato di avere una validità significativa.",
  "known_text": "",
  "target_audio_id": "trial_50D5CBD9-39A0-4A97-A80A-976050BED6D6",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:154",
  "scene_number": 5,
  "sentence_number": 154,
  "global_order": 154,
  "speaker": "Tom",
  "target_text": "Quindi c'è del vero nel praticarla, senza per forza una vera coerenza su perché, su come e su esattamente quanto. È come dire, in generale, che è bene essere gentili con le persone – non sappiamo fino a che punto essere gentili...",
  "known_text": "",
  "target_audio_id": "trial_78948664-26BC-4AED-9E2E-429FA5AC6CE2",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:155",
  "scene_number": 5,
  "sentence_number": 155,
  "global_order": 155,
  "speaker": "Aran",
  "target_text": "Esattamente dove stavo per arrivare. Non mi ricordavo il suo nome, ma credo di avere un vago ricordo di quello – il tizio originale che ha tirato fuori quella cosa. Pimsleur, per quanto ne so, è stato il primo a guardarla davvero nel contesto dell'acquisizione delle lingue.",
  "known_text": "",
  "target_audio_id": "trial_8849E115-F283-47E3-BF8B-3D7922DD2B4B",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:156",
  "scene_number": 5,
  "sentence_number": 156,
  "global_order": 156,
  "speaker": "Aran",
  "target_text": "Quindi ora arriva la cosa interessante – c'è un'altra idea, che non è collegata direttamente, ma finiscono intrecciate.",
  "known_text": "",
  "target_audio_id": "trial_3C97F9D6-F459-4913-BA6B-30E5997B65CF",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:157",
  "scene_number": 5,
  "sentence_number": 157,
  "global_order": 157,
  "speaker": "Aran",
  "target_text": "E questo è un pensiero molto più recente, di un certo dottor Robert Bjork, che lavorava sicuramente all'Università della California – magari ci lavora ancora – ed è l'idea della difficoltà desiderabile. E in fondo è roba simile.",
  "known_text": "",
  "target_audio_id": "trial_F5A4B2D1-9BBC-4B9E-B253-953DF699E72D",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:158",
  "scene_number": 5,
  "sentence_number": 158,
  "global_order": 158,
  "speaker": "Aran",
  "target_text": "Lui individua che quando fai quelle ripetizioni iniziali, il problema è proprio che sono troppo facili.",
  "known_text": "",
  "target_audio_id": "trial_2FEC358E-1A75-4DFC-AEA7-CBB72F68D20A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:159",
  "scene_number": 5,
  "sentence_number": 159,
  "global_order": 159,
  "speaker": "Aran",
  "target_text": "Quindi posso dirti una parola nuova – ti ho detto che in gallese \"pesce\" si dice pysgod – e se poi ti chiedessi di continuare a ripetere pysgod, non stai creando davvero un ricordo in più, perché diventa troppo facile. Pysgod, pysgod.",
  "known_text": "",
  "target_audio_id": "trial_AA3BC389-E7FF-4F92-B7C2-7477D9035CDF",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:160",
  "scene_number": 5,
  "sentence_number": 160,
  "global_order": 160,
  "speaker": "Tom",
  "target_text": "Allora, io me lo ero già un po' ricordato, perché pensavo: \"pys\", è un po' come \"pesce\"? E \"cod\", in inglese, è un pesce, il merluzzo, no? Pysgod.",
  "known_text": "",
  "target_audio_id": "trial_A049B75A-6161-41F6-BA3A-3BB0F1256227",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:161",
  "scene_number": 5,
  "sentence_number": 161,
  "global_order": 161,
  "speaker": "Aran",
  "target_text": "Se lo lasciamo lì, e io torno fra un paio d'ore e ti dico: ti ricordi come si dice \"pesce\" in gallese – sarà difficile. Lo sforzo è un contributo significativo alla formazione del ricordo.",
  "known_text": "",
  "target_audio_id": "trial_8F1855EF-CF93-40BD-8EC5-655215DE59E9",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:162",
  "scene_number": 5,
  "sentence_number": 162,
  "global_order": 162,
  "speaker": "Tom",
  "target_text": "Come lo sappiamo? Sento che è vero. E sembra funzionare? Ma a che punto siamo? Questo lo dice di sicuro il dottor Bjork, ma abbiamo una mappa fatta di studi seri, con revisione tra pari? Quanto deve essere difficile? Stai facendo troppa fatica?",
  "known_text": "",
  "target_audio_id": "trial_D58BB60D-9525-4F4B-870C-11472345A34D",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:163",
  "scene_number": 5,
  "sentence_number": 163,
  "global_order": 163,
  "speaker": "Tom",
  "target_text": "Devi riuscire a recuperare quel ricordo al primo tentativo, o è già prezioso solo l'atto di cercarlo? E poi quando il ricordo non arriva e ti dicono di nuovo la parola pysgod, allora vale molto di più, perché hai dovuto lavorarci e hai dovuto sforzarti.",
  "known_text": "",
  "target_audio_id": "trial_8E535670-6ECE-4254-B6EA-AF8DD6ECFF44",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:164",
  "scene_number": 5,
  "sentence_number": 164,
  "global_order": 164,
  "speaker": "Tom",
  "target_text": "E poi la casella si riempie con la ripetizione che ti dice qualcun altro, perché tu non riuscivi a trovarla...",
  "known_text": "",
  "target_audio_id": "trial_B6F6137A-963A-441E-AC37-496A98DE5D8A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:165",
  "scene_number": 5,
  "sentence_number": 165,
  "global_order": 165,
  "speaker": "Aran",
  "target_text": "Questo è il quadro. Quindi quello che è successo a me mentre leggevo un po' di roba del dottor Bjork sulle difficoltà desiderabili: mi sono ritrovato a pensare, ok, forse quello che succede è che lo sforzo c'entra con la formazione della memoria.",
  "known_text": "",
  "target_audio_id": "trial_67096407-D143-4ED6-B7C6-50EB3DFBAD72",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:166",
  "scene_number": 5,
  "sentence_number": 166,
  "global_order": 166,
  "speaker": "Aran",
  "target_text": "E allora, se lo sforzo c'entra con la formazione della memoria, quello che diceva Pimsleur è in realtà capovolto. Se più sforzo porta a una maggiore ritenzione, allora il momento giusto per riprendere quella parola",
  "known_text": "",
  "target_audio_id": "trial_C8DF17BB-296C-4478-B9F9-6713E0FF3BCD",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:167",
  "scene_number": 5,
  "sentence_number": 167,
  "global_order": 167,
  "speaker": "Tom",
  "target_text": "È subito dopo!",
  "known_text": "",
  "target_audio_id": "trial_F24BDA5B-C29D-4CDB-87F5-AB87FA7AA943",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:168",
  "scene_number": 5,
  "sentence_number": 168,
  "global_order": 168,
  "speaker": "Aran",
  "target_text": "Esatto. Non poco prima, ma un po' dopo – magari subito dopo, o magari molto dopo. Quindi su questo ho delle prove aneddotiche – N uguale 1, ciao, sono io – ma anche di altre persone.",
  "known_text": "",
  "target_audio_id": "trial_147D89EC-8470-4A57-AD48-DB652D00A0E2",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:169",
  "scene_number": 5,
  "sentence_number": 169,
  "global_order": 169,
  "speaker": "Tom",
  "target_text": "Non è aneddotico quando sono tante persone. \"Aneddotico\" è interessante, perché la gente lo liquida in fretta. Ma in realtà – coccodrillo.",
  "known_text": "",
  "target_audio_id": "trial_B700ABE0-DCF1-423C-A45D-3F8CA1C6DE5A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:170",
  "scene_number": 5,
  "sentence_number": 170,
  "global_order": 170,
  "speaker": "Aran",
  "target_text": "Ho perso il piede in quel fiume, vi prego, accettate la mia prova aneddotica! Allora ho cominciato a giocarci, a vedere cosa succede quando ti dai abbastanza tempo per dimenticarla, e di quanto tempo hai bisogno per dimenticarla.",
  "known_text": "",
  "target_audio_id": "trial_DF654974-EA8B-434D-93B3-D793F0DFA2B6",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:171",
  "scene_number": 5,
  "sentence_number": 171,
  "global_order": 171,
  "speaker": "Aran",
  "target_text": "Ed è diventato chiaro velocissimo che quello che ci aspetteremmo normalmente – ok, se non ho lavorato poi così tanto e fra una settimana sarà sparita – assolutamente sbagliato! Una settimana dopo, è ancora un po' troppo facile da recuperare. Allora ho cominciato ad allungare, allungare.",
  "known_text": "",
  "target_audio_id": "trial_A9BAFDCE-8252-4F8B-AF2C-0B1D985B2220",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:172",
  "scene_number": 5,
  "sentence_number": 172,
  "global_order": 172,
  "speaker": "Aran",
  "target_text": "Ho testato fino a 16 mesi, ormai.",
  "known_text": "",
  "target_audio_id": "trial_33E943F9-1957-4217-B946-6AC8A0A30299",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:173",
  "scene_number": 5,
  "sentence_number": 173,
  "global_order": 173,
  "speaker": "Tom",
  "target_text": "Zero richiamo apparente, e poi dopo 16 mesi ti metti alla prova e scopri che c'è una resistenza notevole del ricordo.",
  "known_text": "",
  "target_audio_id": "trial_A02D2A57-23CC-4A24-A710-5BBEBB7D45F0",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:174",
  "scene_number": 5,
  "sentence_number": 174,
  "global_order": 174,
  "speaker": "Aran",
  "target_text": "Quindi quello che tende a succedere, se lavori nel modo in cui lavoriamo noi – quindi ricevi uno stimolo in inglese e poi devi produrre quella cosa nella lingua di arrivo – quando hai lo stimolo per qualcosa che hai imparato 16 mesi fa e non hai più ripassato,",
  "known_text": "",
  "target_audio_id": "trial_271FAAB7-1E40-4A81-BF1C-EFF1E69947A8",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:175",
  "scene_number": 5,
  "sentence_number": 175,
  "global_order": 175,
  "speaker": "Aran",
  "target_text": "tu – garantito al cento per cento – non ti ricorderai quella frase.",
  "known_text": "",
  "target_audio_id": "trial_D5C27627-0140-468C-800E-7A6F5837BD61",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:176",
  "scene_number": 5,
  "sentence_number": 176,
  "global_order": 176,
  "speaker": "Tom",
  "target_text": "Da quello stimolo?",
  "known_text": "",
  "target_audio_id": "trial_3D8B21F9-8108-487B-958D-B25F2B6AEEF0",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:177",
  "scene_number": 5,
  "sentence_number": 177,
  "global_order": 177,
  "speaker": "Aran",
  "target_text": "No. Quindi se ti insegnassi a dire \"voglio guardare il calcio nel weekend\" in mannese... ti porto al punto in cui lo dici in un giorno, e poi lo lasciamo lì, lo molliamo. E 16 mesi dopo torno e ti dico: mi sai dire come si dice in mannese \"voglio guardare il calcio nel weekend\"?",
  "known_text": "",
  "target_audio_id": "trial_E6EDE7A7-DD04-47E4-A23C-B331C9ABFFE5",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:178",
  "scene_number": 5,
  "sentence_number": 178,
  "global_order": 178,
  "speaker": "Aran",
  "target_text": "Dirai di no, non lo so, era 16 mesi fa, ma vaffanculo, amico. Allora io ti dirò com'è. Se poi torno da te il giorno dopo e ti dico: com'è? E tu: ah, ce l'ho. L'ho imparata.",
  "known_text": "",
  "target_audio_id": "trial_862C21B8-CFC6-44D1-A81A-FF3836A7F851",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:179",
  "scene_number": 5,
  "sentence_number": 179,
  "global_order": 179,
  "speaker": "Tom",
  "target_text": "Quindi quello che dici è che non è tanto il dimenticare, è poi il ristimolare.",
  "known_text": "",
  "target_audio_id": "trial_DEDCE3E7-9606-4098-A309-82CE1FABCD1F",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:180",
  "scene_number": 5,
  "sentence_number": 180,
  "global_order": 180,
  "speaker": "Aran",
  "target_text": "La fatica di ricordare, seguita dall'attività di ristimolazione: ripetizione dilazionata. Quindi qui c'è una possibilità. E su questo mancano davvero i dati.",
  "known_text": "",
  "target_audio_id": "trial_C0B63280-F7B5-47E9-97DB-72A75E92A483",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:181",
  "scene_number": 5,
  "sentence_number": 181,
  "global_order": 181,
  "speaker": "Tom",
  "target_text": "Dovremmo far provare questi diversi metodi a miliardi di persone, studiarli e vedere come va. Okay.",
  "known_text": "",
  "target_audio_id": "trial_12E7CCE0-82BB-485D-A212-8C1B1547E13E",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:182",
  "scene_number": 6,
  "sentence_number": 182,
  "global_order": 182,
  "speaker": "Aran",
  "target_text": "C'è la possibilità che ci siano due cursori con cui è interessante giocare, rispetto alla risposta emotiva delle persone al processo di apprendimento. Potresti dire a qualcuno: ti aiutiamo a imparare nel minor tempo possibile.",
  "known_text": "",
  "target_audio_id": "trial_CD3EAAD6-7FF3-462E-A33F-F82E9896E791",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:183",
  "scene_number": 6,
  "sentence_number": 183,
  "global_order": 183,
  "speaker": "Aran",
  "target_text": "Oppure potresti dirgli: ti aiutiamo a imparare col minor sforzo attivo possibile. Quindi se vogliamo farlo nel minor tempo possibile, ti insegneremo la cosa il giorno uno, la ripeteremo il giorno due, il giorno tre, il giorno quattro, il giorno cinque, mescolata con un sacco di altra roba.",
  "known_text": "",
  "target_audio_id": "trial_967B6DF8-0303-4C64-B02D-2ACFF88E4F01",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:184",
  "scene_number": 6,
  "sentence_number": 184,
  "global_order": 184,
  "speaker": "Aran",
  "target_text": "Alla fine l'avrai fatta cinque volte. Avrai avuto cinque giorni in cui la fai più volte. Quindi alla fine di cinque giorni potresti avere, diciamo, 25 ripetizioni, e forse a quel punto sei a posto. In alternativa, te la insegniamo, magari la ripetiamo tre o quattro volte finché non ci riesci.",
  "known_text": "",
  "target_audio_id": "trial_45FB33F7-7D8F-4AC4-822C-152DD571B37E",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:185",
  "scene_number": 6,
  "sentence_number": 185,
  "global_order": 185,
  "speaker": "Aran",
  "target_text": "Appena la dici correttamente, ci fermiamo, finito. Quindi magari ti servono tre tentativi. Poi la lasciamo lì. Torniamo una volta e non te la ricordi, e te la diciamo noi. Poi torniamo di nuovo. Ce l'hai fatta. Hai fatto cinque ripetizioni, ma ormai ce l'hai in tasca.",
  "known_text": "",
  "target_audio_id": "trial_7FFB2808-97D0-420E-B779-7FA78CDDED46",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:186",
  "scene_number": 6,
  "sentence_number": 186,
  "global_order": 186,
  "speaker": "Aran",
  "target_text": "Quindi può darsi che più lungo è l'intervallo tra le ripetizioni dilazionate, meno ripetizioni servono, forse. E allora hai questi due modelli diversi. Dovrebbero trovare un modo per registrare i gesti delle mani, vero!",
  "known_text": "",
  "target_audio_id": "trial_06B788B1-505C-4E5E-B688-A70FC69DF698",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:187",
  "scene_number": 6,
  "sentence_number": 187,
  "global_order": 187,
  "speaker": "Aran",
  "target_text": "È come un asse X e un asse Y: qui c'è il tempo minimo dall'inizio alla capacità, al livello a cui punti, e qui lo sforzo minimo. E potresti dire che vuoi il punto ideale.",
  "known_text": "",
  "target_audio_id": "trial_E17E0E4D-7E12-4D2B-AFA1-C1D5C835DAB6",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:188",
  "scene_number": 6,
  "sentence_number": 188,
  "global_order": 188,
  "speaker": "Aran",
  "target_text": "Se vuoi essere uno che parla una lingua e non ti importa quando succede – è una specie di hobby, qualcosa che ti piacerebbe aver fatto prima dei 60 anni, e adesso ne hai 30 – allora possiamo dirti, ok, ecco l'ora di impegno che ti chiediamo di fare una volta all'anno per i prossimi 30 anni.",
  "known_text": "",
  "target_audio_id": "trial_7F5952A8-1822-4A09-8BB6-2947769A31E8",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:189",
  "scene_number": 6,
  "sentence_number": 189,
  "global_order": 189,
  "speaker": "Aran",
  "target_text": "Alla fine di quel periodo parlerai quella lingua. E questo è il tipo di \"un'ora all'anno per imparare una lingua\" – è un modello che rompe gli schemi, ma credo che più o meno funzionerebbe così.",
  "known_text": "",
  "target_audio_id": "trial_62D5CFC4-A007-4335-94B6-75079612D66D",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:190",
  "scene_number": 6,
  "sentence_number": 190,
  "global_order": 190,
  "speaker": "Aran",
  "target_text": "Di sicuro ultimamente dico alle persone che se riescono a darmi un giorno all'anno, penso ci vorranno tre o quattro anni prima che facciano conversazioni di cui andare piuttosto fieri.",
  "known_text": "",
  "target_audio_id": "trial_FA154356-6733-46BE-96BA-ABD96F92D79E",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:191",
  "scene_number": 6,
  "sentence_number": 191,
  "global_order": 191,
  "speaker": "Tom",
  "target_text": "Allora è interessante, perché saltando su questo, io ho fatto un giorno di cinese mandarino l'estate scorsa. Ne ho fatto un altro quest'anno. E ovviamente era diverso, perché l'abbiamo cambiato, perché stiamo cazzeggiando con la roba – le parole sono diverse, le strutture sono diverse,",
  "known_text": "",
  "target_audio_id": "trial_DEDE7069-DCEB-49E0-AEAA-9A35AFF6D3F7",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:192",
  "scene_number": 6,
  "sentence_number": 192,
  "global_order": 192,
  "speaker": "Tom",
  "target_text": "tutte queste cose – ma ho trovato un vantaggio straordinario nella competenza che sentivo alla fine di quello che era in pratica il secondo giorno – molto più che se avessi lavorato sodo per un mese.",
  "known_text": "",
  "target_audio_id": "trial_4C0F84AF-B2A0-4A91-9BE5-D1082834B315",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:193",
  "scene_number": 6,
  "sentence_number": 193,
  "global_order": 193,
  "speaker": "Tom",
  "target_text": "Solo quel giorno che ho fatto di recente, ho sentito davvero di pensare in cinese, e di cominciare a pensare a queste strutture e a come funzionavano. Ho ascoltato parecchio cinese.",
  "known_text": "",
  "target_audio_id": "trial_ECA166D3-A7EB-4C54-9942-05CFDC51A68F",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:194",
  "scene_number": 6,
  "sentence_number": 194,
  "global_order": 194,
  "speaker": "Tom",
  "target_text": "Non ho provato a parlarlo per niente perché, un po' come te, non voglio imparare una lingua con nessun altro metodo, perché ora che ho assaggiato questo metodo, non voglio provare niente altro – in termini di sforzo totale minimo, il sistema è straordinario. È una pigrizia",
  "known_text": "",
  "target_audio_id": "trial_A9A40DB0-3E6C-4E5D-BDDA-EBDF00CF5511",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:195",
  "scene_number": 6,
  "sentence_number": 195,
  "global_order": 195,
  "speaker": "Aran",
  "target_text": "intelligente, vero?",
  "known_text": "",
  "target_audio_id": "trial_53E89668-5431-4DC3-AF38-D51CF3BB9546",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:196",
  "scene_number": 6,
  "sentence_number": 196,
  "global_order": 196,
  "speaker": "Tom",
  "target_text": "Esatto. Il problema è che se voglio parlare cinese in modo efficace entro la fine di ottobre, non posso usare questo metodo, perché non l'abbiamo ancora finito. Il che è una bella sfida.",
  "known_text": "",
  "target_audio_id": "trial_18FD675A-7FFC-4C03-B4EA-AA737201B24C",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:197",
  "scene_number": 6,
  "sentence_number": 197,
  "global_order": 197,
  "speaker": "Aran",
  "target_text": "Il motivo per cui non parlo nessuna delle altre lingue che non parlo è che – perché dovresti farlo?",
  "known_text": "",
  "target_audio_id": "trial_DC1749A7-812C-4095-A5E7-638C3FE70C80",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:198",
  "scene_number": 6,
  "sentence_number": 198,
  "global_order": 198,
  "speaker": "Aran",
  "target_text": "Non so se hai visto, posso ritirarli fuori dopo, ma ho un paio di video su YouTube delle mie conversazioni con il parlante di mannese dopo il primo giorno intensivo, dopo il secondo giorno intensivo – a 16 mesi di distanza. In realtà adesso è di più.",
  "known_text": "",
  "target_audio_id": "trial_744CB2D2-A0D7-4959-8D1B-7F08D2219446",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:199",
  "scene_number": 6,
  "sentence_number": 199,
  "global_order": 199,
  "speaker": "Aran",
  "target_text": "Il giorno tre – non credo che abbiamo ancora abbastanza materiale per il giorno tre, quindi lo aspetto da un sacco, ma penso che almeno qualcosa ce l'abbiamo, quindi potrei andare a farne un pochino.",
  "known_text": "",
  "target_audio_id": "trial_9EDAF09B-62B3-4215-BEBA-3268290B6874",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:200",
  "scene_number": 6,
  "sentence_number": 200,
  "global_order": 200,
  "speaker": "Aran",
  "target_text": "Il giorno due era quando eravamo qui, quindi è meno di quattro anni, ma saranno circa tre anni ormai da quando ho fatto il giorno due. La conversazione del giorno uno è andata bene. Sono abbastanza contento. Non male.",
  "known_text": "",
  "target_audio_id": "trial_FED53B1A-152A-4A11-B1C7-C5482C687275",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:201",
  "scene_number": 6,
  "sentence_number": 201,
  "global_order": 201,
  "speaker": "Aran",
  "target_text": "La conversazione del giorno due, sentivo decisamente le prime avvisaglie di: ce la posso fare – non troppo lontano dal riuscirci.",
  "known_text": "",
  "target_audio_id": "trial_4E35D107-45A1-4D73-ADB4-B4A62A72781A",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:202",
  "scene_number": 6,
  "sentence_number": 202,
  "global_order": 202,
  "speaker": "Aran",
  "target_text": "C'è un livello di comunicazione – ancora comparativamente limitato, ovviamente – ma dentro quel tipo di comunicazione posso richiamare quasi tutta questa roba e usarla in un sacco di modi diversi. E comincio a sentire che c'è qualcosa che sta succedendo.",
  "known_text": "",
  "target_audio_id": "trial_E33D6DE1-62DE-4088-9483-050937B01106",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:203",
  "scene_number": 6,
  "sentence_number": 203,
  "global_order": 203,
  "speaker": "Aran",
  "target_text": "Non sono neanche lontanamente a 700 parole, neanche lontanamente – probabilmente intorno a un paio di centinaia, più o meno. Quindi in realtà devo smettere di aspettare. Devo darmi una mossa e farlo.",
  "known_text": "",
  "target_audio_id": "trial_0EBCEE52-FA92-4761-8119-6E191BF21D00",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:204",
  "scene_number": 6,
  "sentence_number": 204,
  "global_order": 204,
  "speaker": "Aran",
  "target_text": "Credo che stessi aspettando di arrivare a 15 in un giorno, e non credo di averne 15, ma penso che ce ne siano sette o otto nuove.",
  "known_text": "",
  "target_audio_id": "trial_0D8D0FE3-B2E0-47EB-8FD1-7AE9F26BF2CD",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:205",
  "scene_number": 6,
  "sentence_number": 205,
  "global_order": 205,
  "speaker": "Tom",
  "target_text": "Questo fa nascere la domanda: sarebbe più efficiente imparare 10 lingue in parallelo, un giorno all'anno ciascuna? Così dopo tre anni parli, diciamo, 10 lingue in modo ragionevole. Probabilmente come te, mi interessa lo sforzo totale minimo. Le persone sono impegnate. Le vite sono piene.",
  "known_text": "",
  "target_audio_id": "trial_C38EC0A7-A408-43C1-88FE-391FBDE3D143",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:206",
  "scene_number": 6,
  "sentence_number": 206,
  "global_order": 206,
  "speaker": "Tom",
  "target_text": "Ho tante cose da fare. Se posso fidarmi che funzioni, vorrei farlo in modo efficiente – l'efficienza è la cosa più importante. Quindi so che fra tre anni potrò parlare cinque lingue o 10 lingue. E questo è molto meno sforzo totale che prendersi un anno sabbatico e fare 12 lingue in 12 mesi.",
  "known_text": "",
  "target_audio_id": "trial_02DB3080-38D2-4563-A92A-E7E703DF0D8B",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:207",
  "scene_number": 6,
  "sentence_number": 207,
  "global_order": 207,
  "speaker": "Aran",
  "target_text": "Penso che probabilmente quello che conta davvero è il rapporto emotivo con la lingua o con le lingue. Quindi se hai un bisogno genuino, a breve termine, di cinese, fai un giorno all'anno per i prossimi 10 anni? Non funziona. Quindi tuffati, dacci dentro a martello. Sono 75 dialoghi in 10 giorni.",
  "known_text": "",
  "target_audio_id": "trial_E090E3E4-D4BF-48B2-8BC1-874433EAC5C2",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:208",
  "scene_number": 6,
  "sentence_number": 208,
  "global_order": 208,
  "speaker": "Aran",
  "target_text": "L'efficienza è bellissima, ma lo è anche la velocità.",
  "known_text": "",
  "target_audio_id": "trial_D89C9BD5-01A9-4286-9429-02F2677A25B7",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:209",
  "scene_number": 6,
  "sentence_number": 209,
  "global_order": 209,
  "speaker": "Tom",
  "target_text": "Sì, perché la velocità vuol dire che puoi cominciare a usarla subito. E poi con l'uso ottieni tutti i benefici enormi dell'usarla.",
  "known_text": "",
  "target_audio_id": "trial_72AC197A-7FE4-498F-88FF-384C0801EDAF",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:210",
  "scene_number": 6,
  "sentence_number": 210,
  "global_order": 210,
  "speaker": "Tom",
  "target_text": "Perché quello che cerchiamo di fare nel tuo sistema, più di ogni altra cosa, è portare le persone a conversazioni operative con altre persone, così poi la loro lingua può svilupparsi.",
  "known_text": "",
  "target_audio_id": "trial_730AE546-4B85-4DD7-8B5E-C240617AF9F8",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:211",
  "scene_number": 6,
  "sentence_number": 211,
  "global_order": 211,
  "speaker": "Aran",
  "target_text": "Ci sono delle prove – una volta qualcuno dell'Università di Cardiff mi diceva che si vede un'ampia gamma di percorsi e di tempi per arrivare a 4.000 parole, ma dopo le 4.000 parole sembra tutto più o meno uguale. Quindi quando arrivi a quattromila parole sei in grado di comunicare in quella lingua,",
  "known_text": "",
  "target_audio_id": "trial_18799A8B-552C-4A0C-834B-D9C24D5E6175",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:212",
  "scene_number": 6,
  "sentence_number": 212,
  "global_order": 212,
  "speaker": "Aran",
  "target_text": "e poi in realtà dipende solo da quanto la usi.",
  "known_text": "",
  "target_audio_id": "trial_50D9E5C1-E98C-4FBA-A552-A01E4CAFB713",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 },
 {
  "id": "talk-bollocks-1:213",
  "scene_number": 6,
  "sentence_number": 213,
  "global_order": 213,
  "speaker": "Tom",
  "target_text": "Interessante.",
  "known_text": "",
  "target_audio_id": "trial_15F8FA8E-F5F1-4F55-ADAE-7438B4CCF6E9",
  "known_audio_id": null,
  "sentence_audio_ids": null,
  "sentence_known_audio_ids": null,
  "atom_map_fine": null,
  "window_known_map": null,
  "takeg_audio_ids": null,
  "variant_key": null,
  "attach_sentence_number": null,
  "jump_in": false
 }
]
